<template>
  <section class="report-wrapper" id="pdf-content">
    <b-card no-body>
      <table class="w-100">
        <thead>
          <tr>
            <td>
              <div class="header-space">
                <b-card-body class="report_header pb-0">
                  <div class="company">
                    <h3 class="mb-1 text-left colorBlack">
                      {{ userData.company_name_cn }}
                    </h3>
                  </div>
                  <div class="title d-flex justify-content-between">
                    <h5 class="mb-0 colorBlack">供款提示 <span v-if="!date_range.from && !date_range.to">{{ key_name }}</span></h5>
                    <label>列印時間：{{ getDateTime() }}</label>
                  </div>
                  <div class="info my-1">
                    <b-row>
                      <b-col cols="12">
                        <b-row>
                          <b-col cols="6" v-if="date_range.from || date_range.to">
                            <b-row>
                              <b-col cols="4"><b>供款日期：</b></b-col>
                              <b-col
                                cols="8"
                                v-if="date_range.from"
                                >{{ date_range.from }} - {{ date_range.to }}</b-col
                              >
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col cols="12">
                        <b-row>
                          <b-col cols="6">
                            <b-row>
                              <b-col cols="4"><b>團隊類別：</b></b-col>
                              <b-col
                                cols="8"
                                v-if="team_category"
                                >{{ team_category }}</b-col
                              >
                            </b-row>
                          </b-col>
                          <b-col cols="6">
                            <b-row>
                              <b-col cols="4"><b>貸款類別：</b></b-col>
                              <b-col
                                cols="8"
                                v-if="loan_type"
                                >{{ loan_type }}</b-col
                              >
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col cols="12">
                        <b-row>
                          <b-col cols="6">
                            <b-row>
                              <b-col cols="4"><b>身份證號碼：</b></b-col>
                              <b-col
                                cols="8"
                                v-if="id_number"
                                >{{ id_number }}</b-col
                              >
                            </b-row>
                          </b-col>
                          <b-col cols="6">
                            <b-row>
                              <b-col cols="4"><b>電話號碼：</b></b-col>
                              <b-col cols="8" v-if="phone">{{ phone }}</b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </div>
                </b-card-body>
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <b-card-body class="py-0 report_content">
                <table class="report-table">
                  <thead>
                    <tr>
                      <th>供款日期</th>
                      <th>貸款編號</th>
                      <th>貸款類別</th>
                      <th>借款人姓名</th>
                      <th>身份證號碼</th>
                      <th>客戶電話</th>
                      <th>尚欠期數</th>
                      <th>總期數</th>
                      <th>供款金額</th>
                      <th>附加費用</th>
                      <th>全數清還</th>
                      <th>團隊類別</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item of reportList" :key="item.id">
                      <th>{{ item.pay_date }}</th>
                      <th>{{ item.contract_number }}</th>
                      <th>{{ item.loan_type }}</th>
                      <th>{{ item.name_cn }}</th>
                      <th>{{ item.id_number }}</th>
                      <th>{{ item.mobile }}</th>
                      <th>{{ item.remaining_periods }}</th>
                      <th>{{ item.total_period }}</th>
                      <th>{{ formatCurrency(item.payment_amount) }}</th>
                      <th>{{ formatCurrency(item.total_fee) }}</th>
                      <th>{{ formatCurrency(item.remain_amount) }}</th>
                      <th>{{ item.team_category }}</th>
                    </tr>
                  </tbody>
                </table>
              </b-card-body>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              <div class="footer-space">&nbsp;</div>
            </td>
          </tr>
        </tfoot>
      </table>
      <b-card-body class="report_footer py-0">
        <table class="report-table">
          <tfoot>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th>{{ formatCurrency(total_payment_amount) }}</th>
              <th>{{ formatCurrency(total_additional_fee) }}</th>
              <th>{{ formatCurrency(total_remain_amount) }}</th>
              <th></th>
            </tr>
          </tfoot>
        </table>

        <b
          v-if="loading"
          class="d-flex justify-content-center align-items-center"
        >
          <b-spinner small class="mr-1"></b-spinner>
          載入中...
        </b>
        <b
          v-else-if="reportList.length == 0"
          class="d-flex justify-content-center"
          >沒有過濾或沒有符合條件的數據</b
        >
      </b-card-body>
    </b-card>
  </section>
</template>

<script>
import { BRow, BCol, BCard, BCardBody, BCardText, BSpinner } from "bootstrap-vue";


export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      month: [
        "Jan",
        "Feb",
        "March",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    };
  },
  methods: {},
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardText,
    BSpinner
  },
  props: {
    reportList: {
      type: Array,
      required: true,
    },
    loanTypeOptions: {
      type: Array,
      required: true,
    },
    key_name: {
      type: String,
      required: true,
    },
    phone: {
    },
    id_number: {
    },
    team_category: {
    },
    loan_type: {
    },
    date_range: {
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  mounted() {
    // this.$nextTick(() => {
    //     setTimeout(() => {
    //         this.$emit("domRendered");
    //     }, 1000);
    // });
  },
  computed: {
    total_payment_amount() {
      return this.reportList.reduce(
        (acc, item) => acc + Number(item.payment_amount),
        0
      );
    },
    total_additional_fee() {
      return this.reportList.reduce(
        (acc, item) => acc + Number(item.total_fee),
        0
      );
    },
    total_remain_amount() {
      return this.reportList.reduce(
        (acc, item) => acc + Number(item.remain_amount),
        0
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";
.report-table {
  font-size: 12px;
  tfoot {
    th {
      width: 120px;
    }
  }
  th {
    width: 50px;
    font-size: 11px;
  }
}
</style>